<template>
  <div
    v-if="criterias && Object.keys(criterias).length"
    :class="`is-${mode}`">
    <template 
      v-for="(elem, index) in criterias">
      <div
        v-if="elem.show"
        :key="index"
        class="criterias__item">
        <div class="font-size-14 my-2 text-left bold">
          {{ elem.label }}
        </div>
        <template v-if="elem.isDefault">
          <KeyValue
            v-if="elem.items.warrantyYears"
            :caption="$t('Tenders.Guarantee')"
            data-qa="warrantyYears"
            :value="elem.items.warrantyYears || '–'"/>
          <KeyValue
            v-if="elem.items.termsDelivery"
            :caption="$t('Tenders.TermsOfDelivery')"
            data-qa="termsDelivery"
            :value="elem.items.termsDelivery || '–'"/>
          <KeyValue
            v-if="elem.items.deliveryTime"
            :caption="$t('Tenders.DeliveryTimeInDays')"
            data-qa="termsDelivery"
            :value="elem.items.deliveryTime || '–'"/>
          <KeyValue
            v-if="elem.items.termsPayment"
            :caption="$t('Tenders.TermsOfPayment')"
            data-qa="termsPayment"
            :value="elem.items.termsPayment || '–'"/>
        </template>
        <template v-else>
          <KeyValue
            v-for="(itemCriteria, itemCriteriaIndex) in elem.items"
            :key="itemCriteriaIndex"
            :caption="itemCriteria.title"
            :data-qa="`criteria-${itemCriteriaIndex}`"
            style="max-width: calc((100vw - 360px)/ 4)">
            <span
              v-if="itemCriteria.unitShortTitle"
              slot="captionAfter"
              class="text-capitalize">({{ itemCriteria.unitShortTitle }})</span>
            <span>
              {{ displayValue(itemCriteria.value) }}
              <template v-if="itemCriteria.score !== null">
                : {{ displayValue(itemCriteria.score) }}
              </template>
            </span>
            <DocumentList
              v-if="itemCriteria.attachments"
              :attachments="itemCriteria.attachments"
              data-qa="document-list"
              small/>
          </KeyValue>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import DocumentList from 'components/common/blocks/DocumentList.vue'

import { componentOptions } from 'mixins'

export default {
  name: 'offersCriterasInfo',
  mixins: [ componentOptions ],
  data() {
    return {
      mutableOptions: {
        tender: {
          show: true,
          props: 'ToTender',
          label: this.$t('Tenders.CriteriaToTender')
        },
        lot: {
          show: true,
          props: 'ToLot',
          label: this.$t('Tenders.CriteriaToLot')
        },
        default: {
          show: true,
          props: 'default',
          label: this.$t('Tenders.Criteria')
        },
      }
    }
  },
  methods: {
    decimalCount(num) {
      const numStr = String(num)
      if (numStr.includes('.')) {
        return numStr.split('.')[1].length
      }
      return 0
    },
    displayValue(value) {
      return this.getConvertValue(value) || value
    },
    getConvertValue(value) {
      if (!value) { return value }
      const normalizeNum = (+ (('' + value).replace(/,/,'.')).replace(/\s/g, ''))

      const float = parseFloat(normalizeNum)
      if (float || float === 0) {
        return float.toLocaleString(undefined, { minimumFractionDigits: this.decimalCount(float) || 2, useGrouping: true })
      }
      return normalizeNum
    },
  },
  computed: {
    criterias() {
      if (!this.items?.length) {
        return {}
      }

      const result = {}

      Object.entries(this.mutableOptions).forEach(([key, option]) => {
        if (!option.show) { return }
        const found = this.items.find(el => el.name === option.props)
        if (!found?.items) { return }

        const isDefault = option.props === 'default'

        const hasContent = isDefault
          ? Object.values(found.items).some(v => v !== null)
          : found.items.length > 0

        if (hasContent) {
          result[key] = {
            show: option.show,
            label: option.label,
            isDefault,
            items: found.items,
          }
        }
      })

      return result
    },
  },
  props: {
    items: {
      type: Array
    },
    mode: {
      type: String,
      default: 'col'
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    DocumentList
  }
}
</script>
<style scoped lang="scss">
.is-row {
  gap: 10px;
  display: flex;
  flex-wrap: wrap;
  .criterias {
    &__item {
      display: grid;
      grid-template-columns: repeat(4, minmax(168px, max-content));
      gap: 5px;
      width: 100%;
      & > :first-child {
        grid-column: 1 / -1;
        margin: 0 !important;
        font-weight: 600;
      }
    }
  }
}
</style>
